import React from "react";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Collapse from '@material-ui/core/Collapse';

import CodeIcon from '@mui/icons-material/Code';
import { Link } from "react-router-dom";
import MapIcon from '@mui/icons-material/Map';
import DeveloperBoardIcon from '@mui/icons-material/DeveloperBoard';
import BugReportIcon from '@mui/icons-material/BugReport';

import Style from "../../styles/js/Styles.js";

import placeCategoryService from "../../plas/map/places/categories/service";
import vehiclesService from "../../plas/eboards/vehicles/service";

export default function DeveloperMenu( { open, onExpand } ) {

  const style = Style();

  const [expanded, setExpanded] = React.useState(false);

  React.useEffect(() => {
    if (!open) {
      setExpanded(false);
    }
  }, [open]);

  const onClick = () => {
    if (!expanded) {
      onExpand();
    }
    setExpanded(!expanded);
  }
  
  return (
    <div>
     { (placeCategoryService.canAdmin() || vehiclesService.canAdmin() ) ? (
        <div>
          <ListItem button onClick={onClick}>
            <ListItemIcon>
              <CodeIcon />
            </ListItemIcon>
            <ListItemText className={style.menuTextItem} primary="Desarrollador" />
            { expanded && open ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={expanded && open} timeout="auto" unmountOnExit style={{paddingLeft:"24px"}}>
            <List component="div">
              <div>
                { placeCategoryService.canAdmin() ? (
                  <ListItem button component={Link} to={"/dev/map/places/categories"} >
                    <ListItemIcon>
                      <MapIcon/>
                    </ListItemIcon>
                    <ListItemText className={style.menuTextItem} primary="Categorias de lugares" />
                  </ListItem>) : (null) 
                }
                { vehiclesService.canAdmin() ? (
                  <ListItem button component={Link} to={"/dev/eboards/vehicles/live"} >
                    <ListItemIcon>
                      <DeveloperBoardIcon/>
                    </ListItemIcon>
                    <ListItemText className={style.menuTextItem} primary="Placas electrónicas" />
                  </ListItem>
                  ) : (null)
                }
                { vehiclesService.canAdmin() ? (
                  <ListItem button component={Link} to={"/dev/errors"} >
                    <ListItemIcon>
                      <BugReportIcon/>
                    </ListItemIcon>
                    <ListItemText className={style.menuTextItem} primary="Errores" />
                  </ListItem>
                  ) : (null)
                }
              </div>
            </List>
          </Collapse>
        </div>) : (null) 
     }
    </div>
    
  );
}
